import { useEffect } from 'react'

/**
 * The mockup carried 17 modals as radio-driven overlays. Here there is one
 * component and callers pass content — same markup, same animation.
 *
 * Escape closes, and the backdrop closes. A confirm dialog for something
 * irreversible should pass `dismissible={false}` so neither does: a
 * write-off or a dispute needs a deliberate click, not a stray keypress.
 */
export default function Modal({ title, children, footer, onClose, wide = false, dismissible = true }) {
  useEffect(() => {
    if (!dismissible) return undefined
    const onKey = (e) => e.key === 'Escape' && onClose()
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose, dismissible])

  return (
    <div className="mbk">
      <div className="mbd" onClick={dismissible ? onClose : undefined} />
      <div className={`modal${wide ? ' wide' : ''}`} role="dialog" aria-modal="true">
        <div className="mhead">
          <div className="mtitle">{title}</div>
          <button className="xbtn" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>
        <div className="mbody">{children}</div>
        {footer && <div className="mfoot">{footer}</div>}
      </div>
    </div>
  )
}
